import createTableStore from "ds/components/Table/store/useTableStore";

import { INTENT_PROJECTS_COLUMN_CONFIG, INTENT_PROJECTS_COLUMNS_STORAGE_KEY } from "./constants";

const useIntentProjectsTableStore = createTableStore({
  storageKey: INTENT_PROJECTS_COLUMNS_STORAGE_KEY,
  config: INTENT_PROJECTS_COLUMN_CONFIG,
  version: 9,
});

export default useIntentProjectsTableStore;
